const convertDateDiffToMilliseconds = (endDate, startDate) => {
    const end = endDate instanceof Date ? endDate : new Date(endDate);
    const start = 
    // eslint-disable-next-line no-nested-ternary
    startDate instanceof Date ? startDate : new Date();
    return Math.round(Math.abs(end.getTime() - start.getTime()) / 1000) * 1000;
};
const convertMillisecondsToHumanString = (ms) => {
    const seconds = ms / 1000;
    const leftMinutes = Math.floor(seconds / 60);
    const leftSeconds = leftMinutes ? seconds - leftMinutes * 60 : seconds;
    return `${leftMinutes < 10 ? `0${leftMinutes}` : leftMinutes}:${leftSeconds < 10 ? `0${leftSeconds}` : leftSeconds}`;
};

export { convertDateDiffToMilliseconds, convertMillisecondsToHumanString };
//# sourceMappingURL=time.js.map
